import styled from 'styled-components'

export default styled.section`
  width: 620px;
  background-color: ${ ({ theme }) => theme.colors.white };
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0 50px;

  footer {
    min-height: 104px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px;
    position: relative;

    button {
      width: 180px;
    }
  }

  .react-calendar {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: none;
    font-family: ${ ({ theme }) => theme.fontFamily };
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;

    .react-calendar__navigation__label__labelText {
      font-family: ${ ({ theme }) => theme.fontFamily };
      text-transform: capitalize;
      font-size: 18px;
      letter-spacing: 0;
      line-height: 20px;
    }

    .react-calendar__navigation__arrow {
      font-family: ${ ({ theme }) => theme.fontFamily };
      text-transform: capitalize;
      font-size: 24px;
      letter-spacing: 0;
      line-height: 24px;
    }
    .react-calendar__navigation button:disabled {
      visibility: hidden;
    }

    .react-calendar__viewContainer {
      flex: 1;

      .react-calendar__month-view,
      .react-calendar__year-view
      .react-calendar__century-view {
        height: 100%;

        > div {
          align-items: stretch !important;
          height: 100%;
          justify-content: stretch;
        }
      }

      .react-calendar__month-view__weekdays__weekday {
        font-family: ${ ({ theme }) => theme.fontFamily };
        font-size: 14px;
        font-weight: normal;
      }

      .react-calendar__month-view__days {
        .react-calendar__month-view__days__day {
          font-family: ${ ({ theme }) => theme.fontFamily };
          font-size: 18px;
        }
      }
    }

    .react-calendar__tile {
      border-radius: 6px;
    }
    .react-calendar__tile--now {
      background: ${ ({ theme }) => theme.colors.primary }66;
    }
    .react-calendar__tile--active {
      background: ${ ({ theme }) => theme.colors.primary };
    }
    .react-calendar__tile:disabled {
      color: ${ ({ theme }) => theme.colors.grey };
      background-color: transparent;
    }
  }

  @media screen and (max-width: 768px){
    width: 100%;
    padding: 0 16px;

    header {
      padding: 0 10px !important;
    }

    section {
      padding: 0 10px !important;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    footer {
      padding: 0 10px !important;
      button {
        width: 100px !important;
      }
    }
  }
`